import React from 'react';

const BS_GridSystem = () => {
    return (
        <div>
            <h1>BS_GridSystem Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_GridSystem;
